﻿const config = {
    appId: (document.getElementById('publicClientId') as HTMLInputElement)?.value,
    redirectUri: window.location.origin,
    scopes: [
        "user.read"
    ]
};

export default config;